export enum MaintenanceTicketForms {
  Manage = 'ManageMaintenanceTicket',
  Delete = 'DeleteMaintenanceTicket',
  CreatePhoto = 'CreateMaintenanceTicketPhoto',
  DeletePhoto = 'DeleteMaintenanceTicketPhoto',
  GrantAccess = 'MaintenanceTicketGrantAccess',
}
